import React from "react";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";
import Button, { ButtonStyles } from "./Button.jsx";

const PositionToFlex = {
    left: "--left",
    center: "--center",
    right: "--right",
};

export function BlockHeaderButtonsStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .block-header-buttons-wrap": {
            display: "grid",
            alignItems: "center",

            "&.--left .block-header-buttons-list": {
                justifyContent: "flex-start",
            },

            "&.--center .block-header-buttons-list": {
                justifyContent: "center",
            },

            "&.--right .block-header-buttons-list": {
                justifyContent: "flex-end",
            },

            "& .header-button-wrap": {
                margin: "12px",
            },

            "&.--left .header-button-wrap": {
                marginLeft: "0",
            },

            "&.--right .header-button-wrap": {
                marginRight: "0",
            },

            "& .block-header-buttons-list": {
                width: "100%",
                height: "max-content",
                display: "flex",
                flexWrap: "wrap",
                gridGap: "unset",
            },

            [MobileBreakpoint]: {
                maxHeight: "unset",
                flexDirection: "column",
                justifyContent: "center !important",
                paddingBottom: "30px",

                "& .block-header-buttons-list": {
                    display: "grid",
                },
            },
        },

        ...ButtonStyles(params),
    };
}

export default function BlockHeaderButtons(props) {
    const { Actions } = props.variables;
    const LI = useLoremIpsum();

    const actionButtons = (Actions?.slice().reverse() ?? [LI.button])
        // Empty text to lorem
        ?.map(ab => ({
            ...ab,
            text: ab?.text || LI.button.text,
        }));

    if (!Array.isArray(actionButtons)) {
        console.warn("Action buttons is not array!");
        return null;
    }

    const primaryButtonIndex = actionButtons.length - 1;

    const position = props.position ?? "center";
    const elProps = toElementProps(props, { className: ["block-header-buttons-wrap", PositionToFlex[position]] });
    return (
        <div {...elProps}>
            <div className="block-header-buttons-list">
                {actionButtons?.map((button, index) => {
                    if (index === primaryButtonIndex) {
                        button.primaryButton = true;
                    }

                    button.className = [...(button.className ?? [])];
                    !button.className.includes("without-gradient") && button.className.push("without-gradient");
                    !button.className.includes("ignore-global") && button.className.push("ignore-global");
                    button.className = button.className.filter((v, i, a) => a.indexOf(v) === i);

                    return (
                        <div key={index} className="header-button-wrap">
                            <Button {...button} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
